export default __webpack_public_path__ + "maps-examples-select-layer-thumbnail-480-7b6e32a32f980a99a9a2e296418da20c.png";